import React, { useCallback, useState } from 'react'

import type { EnquiryPopupProps } from '../components/property-details/enquiry-button/enquiry-popup'

type UseEnquiryPopupReturn = {
    isEnquiryPopupOpen: boolean
    EnquiryPopup: React.ComponentType<EnquiryPopupProps> | null
    showEnquiryPopup: () => Promise<void>
    hideEnquiryPopup: () => void
}

export function useEnquiryPopup(): UseEnquiryPopupReturn {
    const [isEnquiryPopupOpen, setIsEnquiryPopupOpen] = useState(false)
    const [EnquiryPopup, setEnquiryPopup] = useState<React.ComponentType<EnquiryPopupProps> | null>(null)

    const showEnquiryPopup = useCallback(async () => {
        if (!EnquiryPopup) {
            const module = await import('../components/property-details/enquiry-button/enquiry-popup')
            setEnquiryPopup(() => module.default as React.ComponentType<EnquiryPopupProps>)
        }
        setIsEnquiryPopupOpen(true)
    }, [EnquiryPopup])

    const hideEnquiryPopup = useCallback(() => setIsEnquiryPopupOpen(false), [])

    return { isEnquiryPopupOpen, EnquiryPopup, showEnquiryPopup, hideEnquiryPopup }
}
